import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './PopoverElement.scss'

const PopoverElement = ({ label, link, onClick, icon, warning }) => {
	return (
		<a
			href={link}
			onClick={onClick}
			styleName={warning ? 'link-warning' : 'link'}
			target="_blank"
			rel="noopener"
		>
			<i className="material-icons" styleName="icon">
				{icon}
			</i>
			<div styleName="label">{label}</div>
		</a>
	)
}
export default CSSModules(PopoverElement, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Overlay/PopoverElement.js